module.exports = __webpack_public_path__ + "static/media/vip-trophy-1.c4c8ac58.png";